module.exports = __webpack_public_path__ + "i18n/nl.5622e6024f18eb3476efcc4df330ce97.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/nl.json
// module id = 1006
// module chunks = 60